import { Gantt } from "@/shared/components/gantt";
import type { GanttColumn, GanttRow } from "@/shared/components/gantt";

import { marcaDaLinha, rowActions, segmentRowMinHeight } from "../../gantt-fornecedor.utils";
import { GanttFornecedorConteudo } from "../gantt-fornecedor-conteudo";
import { GanttFornecedorNome } from "../gantt-fornecedor-nome";
import { SIMULACAO_MARCA_CLASSES } from "@/shared/components/simulacao-marca";
import type { GanttFornecedorViewModel } from "./types-gantt-fornecedor";
import ganttStyles from "@/shared/components/gantt-carga/gantt.module.scss";
import styles from "../../carga-fornecedor-gantt.module.scss";

/**
 * Gantt do Fornecedor agrupado por fornecedor: a mesma estrutura (`Gantt.Root`) e o mesmo desenho
 * de barras do Gantt de Profissionais, com linhas compactas e só o nome e o selo de conflito.
 */
export function GanttFornecedorView({
  rows,
  marcas,
  today,
  onConflictHover,
  onConflictLeave,
  onResolverConflito,
  scale,
  unitMinWidth,
}: GanttFornecedorViewModel) {
  const columns: GanttColumn[] = [
    {
      key: "fornecedor",
      header: "Fornecedor",
      width: "var(--gantt-left)",
      cellClassName: styles.nameCell,
    },
  ];

  const tableRows: GanttRow[] = rows.map((row) => {
    const actions = rowActions(
      row.conflicts > 0,
      onResolverConflito && (() => onResolverConflito(row)),
    );

    return {
      key: row.key,
      testId: "gantt-row-profissional",
      className: marcaDaLinha(marcas, row) ? SIMULACAO_MARCA_CLASSES.linha : undefined,
      minHeight: segmentRowMinHeight(row.lanes),
      actionLabel: actions ? `Ações de ${row.title}` : `Detalhes de ${row.title}`,
      actions,
      cells: [
        <GanttFornecedorNome
          key="name"
          row={row}
          marca={marcaDaLinha(marcas, row)}
          onConflictHover={onConflictHover}
          onConflictLeave={onConflictLeave}
        />,
      ],
      content: (
        <GanttFornecedorConteudo
          row={row}
          variant="segment"
          marcas={marcas}
          onConflictHover={onConflictHover}
          onConflictLeave={onConflictLeave}
        />
      ),
    };
  });

  return (
    <Gantt.Root
      grid="none"
      className={`${ganttStyles.root} ${styles.fornecedorRoot}`}
      corpoRola
      scale={scale}
      today={today}
      todayLabel="Hoje"
      columns={columns}
      rows={tableRows}
      withActions
      unitMinWidth={unitMinWidth}
    />
  );
}
